import React, { memo, useEffect, useState } from 'react';
import { Image, Linking, Text, TouchableOpacity, View } from 'react-native';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import he from 'he';

import { useInjectReducer } from '../../utils/injectReducer'; // eslint-disable-line

import Title from '../../components/Content/Title';
import Logo from '../../assets/images/logo-black.png';
import LocationPermission from '../../assets/images/locationPermission.png';
import styles from './styles';

import reducer from './reducer';
import makeSelectDashboard from './selectors';
import { makeSelectUser } from '../../providers/UserProvider/selectors';
import Search from '../Search';
import { Ionicons } from '@expo/vector-icons';
import login from '../../services/login';
import Modal from '../../services/modal';
import SubTitle from '../../components/Content/SubTitle';
import EStyleSheet from 'react-native-extended-stylesheet';
import { ScrollView } from 'react-native';
import Paragraph from '../../components/Content/Paragraph';
import * as Location from 'expo-location';
import { trackUserLocation } from '../../services/tracking';
import * as Notifications from 'expo-notifications';
import { Platform } from 'react-native';
import { Alert } from 'react-native';

const key = 'dashboard';

const aspectRatio = 3.5;

function Dashboard({ user }) {
	useInjectReducer({ key, reducer });
	const [showModal, setShowModal] = useState(false);
	const [permissionChecker, setPermissionChecker] = useState(false);

	useEffect(() => {
		const checkBackgroundPermissions = async () => {
			if (permissionChecker) {
				// Background location
				const config = await login.getGlobalConfig();
				const currentUser = await login.getUser();
				if (config?.askForBackgroundPermission && currentUser?.allowGeofencing !== null && currentUser?.allowGeofencing) {
					const bg = await Location.getBackgroundPermissionsAsync();
					console.log(bg?.status, 'bg');
					if (bg?.status === 'granted') {
						setPermissionChecker(false);
						clearTimeout(timeout);
						checkPermissions();
					}
				}
			}
		}
		const timeout = setTimeout(() => {
			checkBackgroundPermissions();
		}, 2000);
	}, [permissionChecker]);

	const checkPermissions = async () => {
		try {
			let modalShouldBeShown = false;
			const config = await login.getGlobalConfig();

			// Check Android notifications permission for FGS (Android 13+)
			let notifGranted = true;
			if (Platform.OS === 'android') {
				const notif = await Notifications.getPermissionsAsync();
				notifGranted = notif?.status === 'granted';
				if (!notifGranted) {
					const req = await Notifications.requestPermissionsAsync();
					notifGranted = req?.status === 'granted';
				}
			}

			// Foreground location
			let fgGranted = true;
			if (config?.askForForegroundPermission) {
				const fg = await Location.getForegroundPermissionsAsync();
				fgGranted = fg?.status === 'granted';
			}

			// Background location
			let bgGranted = true;
			if (config?.askForBackgroundPermission) {
				const bg = await Location.getBackgroundPermissionsAsync();
				bgGranted = bg?.status === 'granted';
			}

			// If config missing, require showing modal to re-request cleanly
			if (!config) {
				modalShouldBeShown = true;
			}

			const currentUser = await login.getUser();
			console.log(currentUser, 'user details');
			const geofencingAllowed = currentUser?.allowGeofencing !== null && currentUser?.allowGeofencing;

			// Decide: start tracking or show modal
			if (geofencingAllowed && notifGranted && fgGranted && bgGranted && !!config) {
				// All permissions present, start tracking silently
				setShowModal(false);
				trackUserLocation(true);
			}
			if (geofencingAllowed && !fgGranted) {
				// Missing something; show modal to request
				setShowModal(true);
			}
			if (geofencingAllowed && !bgGranted) {
				// Missing something; show modal to request
				setShowModal(true);
			}
			if (geofencingAllowed && !notifGranted) {
				Alert.alert(
					'Enable Notifications',
					'Please grant notification permission to start background tracking.',
					[
						{ text: 'Cancel', style: 'cancel' },
						{ text: 'Go to Settings', onPress: () => { try { Linking.openSettings(); } catch (e) { } } },
					]
				);
				return;
			}
		} catch (err) {
			console.warn(err);
		}
	};
	useEffect(() => {

		setTimeout(() => {
			checkPermissions();
		}, 3000);
	}, []);

	const onAccept = async () => {
		try {
			setShowModal(false);

			const config = await login.getGlobalConfig();
			let foregroundPermission = null;

			if (config?.askForForegroundPermission) {
				foregroundPermission = await Location.requestForegroundPermissionsAsync();
				if (foregroundPermission.status !== 'granted') {
					console.warn('Foreground permission not granted');
					return;
				}
			}

			if (Platform.OS === 'android') {
				const notif = await Notifications.getPermissionsAsync();
				if (notif?.status !== 'granted') {
					const req = await Notifications.requestPermissionsAsync();
					if (req?.status !== 'granted') {
						console.warn('Notification permission not granted');
						return;
					}
				}
			}

			// Check if we need to request background permission
			if (config?.askForBackgroundPermission) {
				// First check current background permission status
				const currentBackground = await Location.getBackgroundPermissionsAsync();

				// If background permission is not granted, request it
				if (currentBackground.status !== 'granted') {
					const background = await Location.requestBackgroundPermissionsAsync();
					console.log(background.status, 'background permission status');

					if (background.status !== 'granted') {
						// If user denied background permission, show alert to go to settings
						Alert.alert(
							'Background Location Required',
							'To provide uninterrupted location tracking, please enable "Allow all the time" location permission in your device settings.',
							[
								{ text: 'Cancel', style: 'cancel' },
								{
									text: 'Go to Settings', onPress: () => {
										try {
											Linking.openSettings();
											setPermissionChecker(true);
										} catch (e) {
											console.warn('Could not open settings:', e);
										}
									}
								},
							]
						);
						return;
					}
				}
			}

			// Start/ensure background tracking when user accepts
			trackUserLocation(true);
		} catch (error) {
			console.warn(error);
		}
	}
	return (
		<>
			{showModal &&
				<Modal
					backdropColor={EStyleSheet.value('$white')}
					style={{ margin: 20 }}
					backdropOpacity={0.95}
					isVisible={showModal}
					onBackdropPress={setShowModal}
					onBackButtonPress={setShowModal}
					animationIn="zoomIn"
					animationOut="zoomOut"

					scrollHorizontal={true}
				>
					<ScrollView>
						<View style={{ padding: 10, marginTop: 20, alignItems: "center" }}>
							<SubTitle>Use Your Location</SubTitle>
							<Paragraph content={`SafeBuilding collects location data to enable Geofence even when the app is closed or not in use.`}></Paragraph>
							<SubTitle title={`Please Select ‘Allow All the Time’ for location permissions for smooth & uninterrupted service.`}></SubTitle>
							<Paragraph content={`SafeBuilding may collect and use your device’s location information to provide specific features or services. This information can include precise or approximate location data, such as GPS coordinates or information derived from nearby Wi-Fi networks and cell towers.`}></Paragraph>

							<TouchableOpacity
								onPress={() => {
									try {
										Linking.openURL(`https://www.safebuildings.ca/legal-privacy`);
									} catch (error) {
										//console.log(error, 'error');
									}
								}}
							>
								<Paragraph content={`For more detailed information please visit at https://www.safebuildings.ca/legal-privacy.`}></Paragraph>
							</TouchableOpacity>
							<Image style={{ height: 200, width: 200, marginTop: 10 }} source={LocationPermission}></Image>
							<View style={{ marginTop: EStyleSheet.value('2rem'), justifyContent: "space-between", flexDirection: "row" }}>
								<TouchableOpacity style={{ marginHorizontal: EStyleSheet.value('4rem') }} onPress={() => { setShowModal(false) }}>
									<SubTitle>DENY</SubTitle>
								</TouchableOpacity>

								<TouchableOpacity style={{ marginHorizontal: EStyleSheet.value('4rem') }} onPress={async () => { await onAccept() }}>
									<SubTitle>ACCEPT</SubTitle>
								</TouchableOpacity>
							</View>
						</View>
					</ScrollView>
				</Modal>
			}
			<Search
				header={(
					<>
						<Image
							style={[styles.logo, { aspectRatio }]}
							source={Logo}
							resizeMode="contain"
						/>
						<Title title={`Welcome ${he.decode(user?.firstName ?? '')}`} />
						{/* <View style={{ flexDirection: "row",marginTop:-10 }}>
						<Ionicons name="md-thunderstorm-outline" style={styles.searchIcon} />
						<Text style={styles.tmp}>{`  Thunder Storm`}</Text>
						<Text style={styles.tmp}>{`        26°C`}</Text>
					</View> */}

					</>
				)}
			/>
		</>
	);
}

const mapStateToProps = createStructuredSelector({
	dashboard: makeSelectDashboard(),
	user: makeSelectUser(),
});

export function mapDispatchToProps(dispatch) {
	return {
		dispatch,
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDispatchToProps,
);

export default compose(
	withConnect,
	memo,
)(Dashboard);
